import { logUsage } from 'owa-analytics';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { isOcpsPolicyEnabled, OcpsPolicy } from 'owa-ocps-policy-store';
import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';

export function isSupportEnabled(): boolean {
    const contactSupportPolicy = isOcpsPolicyEnabled(OcpsPolicy.ContactSupport, true);
    const diagnosticsTroubleshootingtPolicy = isOcpsPolicyEnabled(
        OcpsPolicy.DiagnosticsTroubleshooting,
        true
    );

    // User-initiated UI action within the current module context
    logUsage('DiagnosticsAndSupport_IsSupportEnabled_Old', getModuleContextMailboxInfo(), {
        isSupportFlightEnabled: isAccountFeatureEnabled(
            'mon-diag-inappsupport',
            getGlobalSettingsAccountMailboxInfo()
        ),
        isSupportPolicyEnabled: contactSupportPolicy,
        isTroubleshootingPolicyEnabled: diagnosticsTroubleshootingtPolicy,
    });
    return (
        isAccountFeatureEnabled('mon-diag-inappsupport', getGlobalSettingsAccountMailboxInfo()) &&
        (contactSupportPolicy || diagnosticsTroubleshootingtPolicy)
    );
}
